/* t7-3 remate 4 (Bloque C): LA BARRA DE ARRIBA DEL AVANCE DEL GRUPO, SEGUN LO QUE CABE.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   La disposicion de computadora (renglon 1: el boton de regresar y, a su derecha, la leyenda en una linea;
   renglon 2: el titulo y el boton del chat) se usa SOLO cuando cabe: W >= L + 20 + 300, con W el ancho
   interior real de la barra y L el ancho natural de la leyenda en una linea en el idioma actual, los dos
   MEDIDOS. Asi el boton de regresar siempre dispone de 300 px o mas. Si no cabe, la barra se porta como en el
   telefono, sea cual sea el ancho de la ventana. (Antes: un corte fijo de 1024 px de ventana, que no contaba el
   menu lateral.)

   W: la barra se estira de borde a borde con el MISMO relleno que el contenido (su margen negativo y su
   relleno valen lo mismo), asi
   que su ancho interior es el ancho de la caja del panel. L: la suma de los botones de la leyenda mas sus
   huecos; sus botones no se encogen, asi que la cuenta vale tanto si la leyenda va en la barra como debajo. En
   el esqueleto de carga no hay leyenda: lleva un medidor oculto e inerte (ver la pagina).

   Las dos medidas se toman en `useLayoutEffect`, ANTES de pintar (sin parpadeo), y se repiten con
   `ResizeObserver` y al terminar de cargar las fuentes. Sin medida (jsdom, o la primera vuelta) la regla dice
   `null` y la pagina conserva la disposicion de computadora, que es la de siempre en las pruebas.

   post-t7-2b (D1): LA REGLA NUEVA ES W >= L + 3 x 20 + R. Lo de arriba (L + 20 + 300) se queda como historia.
   (1) El grid de la barra tiene CUATRO columnas (el boton, un espacio libre, la leyenda y otro espacio libre), o sea
   TRES huecos de 20, y la regla vieja solo descontaba uno: con W = L + 320 al boton le quedaban 260, no los 300 que
   prometia. Ahora se cuentan los tres (`HUECOS_DE_LA_BARRA`), y el hueco es el MISMO numero que pinta la pagina
   (`HUECO_DE_LA_BARRA`). (2) R, la reserva del boton de regresar, es su ancho REAL en la disposicion de computadora
   (B, medido en un medidor oculto con su letra y su relleno) cuando es menor que el minimo, y el minimo si no. (3) El
   minimo baja de 300 a 220: con el boton mas angosto que su nombre, el nombre parte renglon DENTRO del boton, como en
   el telefono. Sin B (el esqueleto, que no conoce el nombre), R es el minimo: el esqueleto nunca dice "computadora"
   donde la pagina diria "telefono". Medido en Chrome con la foto del demo, a 1281 por 954 con el menu lateral: W de
   930 a 945 segun la barra de desplazamiento, L de 595.9 (ES) y 626.8 (EN) con la leyenda nueva, B de 258.5.

   Remate de post-t7-2c (R4, "3. si" de Carlos): LA RESERVA ES B ENTERO CUANDO SE MIDIO. R = B si B > 0 (el ancho
   natural del boton con el nombre ENTERO en una linea, el del medidor oculto `MedidorDelVolver`), y el minimo solo sin
   medida (el esqueleto que no conoce el nombre). O sea: la disposicion de computadora se usa unicamente cuando el
   nombre cabe entero en un renglon; si no, la del telefono. LAPIDA: murio R = min(B, minimo) de la 2b (2) y (3): con
   el boton mas ancho que el minimo se le apartaban 220 y, desde D3 de la 2c (el nombre en un renglon), el nombre se
   cortaba con puntos suspensivos en una franja de computadoras (el demo a 1240 ES y 1280 EN). Cae tambien la promesa
   de arriba: el esqueleto SIN nombre (reserva 220) puede decir "computadora" donde la pagina, ya con B, diga
   "telefono". Con los numeros de arriba, a 1281 con el menu cabe en ES (595.9 + 60 + 258.5 = 914.4) y en EN pide
   945.3, mas que el W mas ancho (945). */
import { useEffect, useLayoutEffect, useState } from 'react';

/** post-t7-2b (D1): el hueco entre columnas del grid de la barra de computadora y cuantos son (cuatro columnas, tres
    huecos). LAPIDA: murio `AIRE_DE_LA_LEYENDA` (20, uno solo). */
export const HUECO_DE_LA_BARRA = 20;
export const HUECOS_DE_LA_BARRA = 3;
/** El ancho minimo que se le aparta al boton de regresar en la computadora. post-t7-2b (D1): 220 (antes 300). Remate
    de post-t7-2c (R4): solo cuando el boton no se midio (el esqueleto sin nombre). */
export const MINIMO_DEL_BOTON = 220;

/** La reserva del boton: su ancho natural `B` entero cuando se midio (mayor o menor que el minimo); el minimo solo si no
    se midio. Remate de post-t7-2c (R4). LAPIDA: era `min(B, minimo)` (post-t7-2b, D1). */
export function reservaDelBoton(B) {
  return B > 0 ? B : MINIMO_DEL_BOTON;
}

/** Remate de post-t7-2c (R4.2, "Recordar el ancho en el aparato"): el esqueleto que no conoce el nombre del grupo (la
    entrada directa o la recarga) decide con el B que la pagina midio en la visita anterior a ESE grupo. Vive en lo que
    el aparato ya recuerda de cada grupo (`lib/esqueletoDelAvance.js`: `localStorage`, llave por id de grupo, con su
    try/catch y su tope de grupos), dentro de `barra`, como `B`: un numero, sin el nombre del grupo ni datos de nadie.
    La primera visita directa a un grupo sigue sin B y decide con el minimo (puede brincar). */

/** El B recordado de un grupo (el objeto de `recuerdoDelGrupo`): un numero positivo, o 0 si no hay. */
export function botonDelRecuerdo(recuerdo) {
  const B = recuerdo && recuerdo.barra ? recuerdo.barra.B : 0;
  return typeof B === 'number' && Number.isFinite(B) && B > 0 ? B : 0;
}

/** La barra que se recuerda con el B medido (redondeado HACIA ARRIBA a centesimos: el esqueleto nunca dice
    "computadora" donde la pagina diria "telefono"). Sin B medido, la barra tal cual venia. */
export function barraConElBoton(barra, B) {
  if (!(typeof B === 'number' && Number.isFinite(B) && B > 0)) return barra || undefined;
  // el 1e-6 absorbe el error de coma flotante (258.47 x 100 = 25847.000000000004 no debe subir a 258.48)
  return { ...(barra || {}), B: Math.ceil(B * 100 - 1e-6) / 100 };
}

/** Remate de post-t7-2c (decision de Carlos del 15-oct): en el telefono el nombre parte hasta dos renglones y la barra
    puede crecer, asi que tambien se recuerda el alto REAL de la barra del telefono de cada grupo, con el ancho y el
    idioma en que se midio (`barra.telefono`), y el esqueleto lo reserva si coinciden. La medida de computadora sigue
    donde estaba (`barra.lang`, `barra.W`, `barra.alto`). */
const unDecimal = (v) => Math.round(v * 10) / 10;

/** La barra que se recuerda de un grupo despues de pintar la pagina: `previa` (la recordada), la disposicion
    (`enBarra`), el idioma, el ancho `W` y el alto real `alto` de la barra, y el B medido del boton. */
export function barraRecordada(previa, { enBarra, lang, W, alto, B } = {}) {
  let nueva = previa || undefined;
  if (alto > 0 && W > 0) {
    const medida = { lang, W: unDecimal(W), alto: unDecimal(alto) };
    nueva = enBarra
      ? { ...medida, ...(previa && previa.telefono ? { telefono: previa.telefono } : {}),
        ...(previa && previa.B ? { B: previa.B } : {}) }
      : { ...(previa || {}), telefono: medida };
  }
  return barraConElBoton(nueva, B);
}

/** El alto recordado de la barra del telefono de un grupo (el objeto de `recuerdoDelGrupo`) a este ancho (a menos de
    1 px) y en este idioma; 0 si no hay. */
export function altoDelTelefonoDelRecuerdo(recuerdo, W, lang) {
  const t = recuerdo && recuerdo.barra ? recuerdo.barra.telefono : null;
  if (!t || t.lang !== lang || !(Math.abs((t.W || 0) - W) < 1)) return 0;
  return typeof t.alto === 'number' && Number.isFinite(t.alto) && t.alto > 0 ? t.alto : 0;
}

/** `true` si cabe la disposicion de computadora, `false` si no, `null` sin medidas. `B`: el ancho natural del boton
    de regresar (0 o ausente si no se midio). */
export function cabeLaBarraDeComputadora(W, L, B = 0) {
  if (!(W > 0) || !(L > 0)) return null;
  return W >= L + HUECOS_DE_LA_BARRA * HUECO_DE_LA_BARRA + reservaDelBoton(B);
}

/** El ancho natural del boton de regresar: el de su medidor oculto (0 sin medidor). */
export function anchoNaturalDelBoton(medidor) {
  if (!medidor) return 0;
  return (medidor.getBoundingClientRect() || {}).width || 0;
}

/** El ancho natural de la leyenda en una linea: sus botones y los huecos entre ellos (0 sin leyenda). */
export function anchoNaturalDeLaLeyenda(leyenda) {
  if (!leyenda) return 0;
  const botones = Array.from(leyenda.children || []).filter((n) => n.tagName === 'BUTTON');
  if (!botones.length) return 0;
  const estilo = typeof window !== 'undefined' && window.getComputedStyle ? window.getComputedStyle(leyenda) : null;
  const hueco = estilo ? (parseFloat(estilo.columnGap) || 0) : 0;
  const suma = botones.reduce((s, b) => s + ((b.getBoundingClientRect() || {}).width || 0), 0);
  return suma > 0 ? suma + hueco * (botones.length - 1) : 0;
}

/** `{ W, L, B }` medidos sobre la raiz del panel. `anchoConocido`: el de `useAnchoDeCaja`, si la raiz no mide;
    `clave`: lo que cambia la leyenda o el boton (el idioma, si se pinta el esqueleto o la pagina, y el nombre del
    grupo): con ella se vuelve a medir. post-t7-2b (D1): B, el ancho natural del boton de regresar, sale del medidor
    `[data-medidor-volver]` de la pagina (0 en el esqueleto, que no lo tiene). */
export function useMedidasDeLaBarra(raizRef, anchoConocido = 0, clave = '') {
  const [medidas, setMedidas] = useState({ W: 0, L: 0, B: 0 });
  const [vuelta, setVuelta] = useState(0);
  useLayoutEffect(() => {
    const raiz = raizRef && raizRef.current;
    if (!raiz) return;
    const W = (raiz.getBoundingClientRect() || {}).width || anchoConocido || 0;
    const L = anchoNaturalDeLaLeyenda(raiz.querySelector('[data-leyenda]'));
    const B = anchoNaturalDelBoton(raiz.querySelector('[data-medidor-volver]'));
    setMedidas((m) => (Math.abs(m.W - W) < 0.5 && Math.abs(m.L - L) < 0.5 && Math.abs(m.B - B) < 0.5 ? m : { W, L, B }));
  }, [raizRef, anchoConocido, vuelta, clave]);
  useEffect(() => {
    const raiz = raizRef && raizRef.current;
    const otraVez = () => setVuelta((v) => v + 1);
    let observador = null;
    if (raiz && typeof ResizeObserver !== 'undefined') {
      observador = new ResizeObserver(otraVez);
      observador.observe(raiz);
    }
    if (typeof document !== 'undefined' && document.fonts && document.fonts.ready) document.fonts.ready.then(otraVez);
    return () => { if (observador) observador.disconnect(); };
  }, [raizRef]);
  return { ...medidas, vuelta };
}
